/**
 * LAUNCH MOINTOR REPORT Reducers
 */
import {
    LAUNCHREPORT_ACTION,
    ALL_LAUNCHREPORT,
    ADD_LAUNCHREPORT,
    DELETE_LAUNCHREPORT,
    EDIT_LAUNCHREPORT
} from 'Actions/types';


const INIT_STATE = {
    launchreportlist: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case LAUNCHREPORT_ACTION:
            return { ...state, loading: true };

        case ALL_LAUNCHREPORT:
            return { ...state, loading: false, launchreportlist: action.payload };

        case EDIT_LAUNCHREPORT:
            return { ...state, loading: false, launchreportlist: action.payload };

        case ADD_LAUNCHREPORT:
            return { ...state, loading: false };

        case DELETE_LAUNCHREPORT:
            return { ...state, loading: false };

        default: return { ...state };

    }
}
